import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { PITEventService, UtilsMisc } from '@pit/core';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreFacade } from '@pit/core-store';
import { IDtoShipmentProcess } from '@pit/frontend-model';
import { DtoShipmentProcessStoreFactory } from './dto.shipment.process.store.factory';
import { IDtoShipmentProcessEntityDataService } from '../../module.data/services/interfaces/dto.shipment.process.entity.data.service.interface';

@Injectable({
    providedIn: 'root'
})
export class DtoShipmentProcessStoreFacade extends EntityStoreFacade<IDtoShipmentProcess> {

    constructor(store: Store<IDtoShipmentProcess>, dataServiceAccessor: EntityDataServiceAccessorService, eventService: PITEventService) {
        super(DtoShipmentProcessStoreFactory.instance, store, 'DtoShipmentProcess', dataServiceAccessor, eventService);
    }

    public loadShipmentProcessesActiveForDepot$(depotNumber: string): void {
        this.store.dispatch(this.entityStoreFactory.getAction('get.active.by.depot')({ depotNumber: depotNumber }));
    }

    public async loadShipmentProcessesActiveForDepotAsync(depotNumber: string): Promise<IDtoShipmentProcess[]> {
        let result: IDtoShipmentProcess[] = null;
        try {
            const queryResult: IDtoShipmentProcess[] = await (this.dataServiceAccessor.getEntityDataService<IDtoShipmentProcess>(this.entityStoreFactory.dataAccessName.toLowerCase()) as IDtoShipmentProcessEntityDataService).getActiveShipmentProcessesForDepotAsync(depotNumber);
            this.clear();
            if ((UtilsMisc.isNullOrUndefined(queryResult) === false) && (queryResult.length > 0)) {
                result = queryResult;
                this.upsertItemsToStore(result);
            }
        } catch (error) {
            this.eventService.useMethod('error.show', error);
        } finally {
        }

        return result;
    }

    public loadShipmentProcessesToReturnForDepot$(depotNumber: string, includeInDelivery: boolean = false): void {
        this.store.dispatch(this.entityStoreFactory.getAction('get.returns.by.depot')({ depotNumber: depotNumber, includeInDelivery: includeInDelivery }));
    }

    public async loadShipmentProcessesToReturnForDepotAsync(depotNumber: string, includeInDelivery: boolean = false): Promise<IDtoShipmentProcess[]> {
        let result: IDtoShipmentProcess[] = null;
        try {
            const queryResult: IDtoShipmentProcess[] = await (this.dataServiceAccessor.getEntityDataService<IDtoShipmentProcess>(this.entityStoreFactory.dataAccessName.toLowerCase()) as IDtoShipmentProcessEntityDataService).getShipmentProcessesToReturnForDepotAsync(depotNumber, includeInDelivery);
            this.clear();
            if ((UtilsMisc.isNullOrUndefined(queryResult) === false) && (queryResult.length > 0)) {
                result = queryResult;
                this.upsertItemsToStore(result);
            }
        } catch (error) {
            this.eventService.useMethod('error.show', error);
        } finally {
        }

        return result;
    }

}
